module.exports = __webpack_public_path__ + "media/images/emblems/St_Niklaus_Wappen-26bfd4a3b6ca4ab27133b1d7b8bb74f6.png";